<div *ngIf="initApp" [class.has-mobile-footer]="!isUnauthorized() && (isOciUser$ | async) === false && (showFooter$ | async)">
        <app-nav-desktop
            [isAuthorized]="!isUnauthorized()"
            [allowedToOrder$]="allowedToOrder$"
            [isOciUser]="isOciUser$ | async"
            [corporateClientName]="corporateClientName$ | async"
            (logout)="logout()"
        ></app-nav-desktop>
        <app-nav-mobile
            [isAuthorized]="!isUnauthorized()"
            [isOciUser]="isOciUser$ | async"
            (logout)="logout()"
        ></app-nav-mobile>
        <div class="content">
            <div class="browser-not-supported-banner" *ngIf="!browserSupported"><i class="icon icon__left icon-warning"></i>{{ 'LABELS.BROWSER_NOT_SUPPORTED' | translateApplicationName | async }}</div>
            <div class="maintenance-banner" *ngIf="!!bannerText"><i class="icon icon__left icon-warning"></i>{{ bannerText }}</div>
            <div class="content__content">
                <div>
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
        <app-nav-footer *ngIf="!isUnauthorized()" [allowedToOrder$]="allowedToOrder$"></app-nav-footer>
</div>
